import { useSocket } from '@data-phone/react-resource-server-auth';
import React, { useEffect } from 'react';
import { useAppDispatch } from '../redux/hooks';
import {
  removeAllCallCenterHoldCalls,
  removeCallCenterCallByAgentId,
  updateCallCenterCalls,
} from '../redux/slices/CallCenterSlices/callCenterCalls.slice';
import {
  createAgentsOffering,
  removeAgentsByAgentsId,
  removeAgentsOfferingBySessionId,
} from '../redux/slices/CallCenterSlices/agentsOffering.slice';
import {
  removeActiveCallsCallCenter,
  removeAllActiveCallCenterData,
  updateActiveCallsCallCenter,
} from '../redux/slices/CallCenterSlices/activeCallCenter.slice';
import { updateCallCenterAgentStatus } from '../redux/slices/CallCenterSlices/activeAgents.slice';

export const useCallCenterSocket = () => {
  const dispatch = useAppDispatch();
  const { socket } = useSocket({
    socketUrl: `${process.env.REACT_APP_LIVE_CALL_WSS}/callCenter`,
    path: "",
  });

  useEffect(() => {
    if (!socket) return;

    socket.on("connect", () => {
      console.log("✅ Call Center Socket connected");

      // Optional: inject mock call
      /*
      setTimeout(() => {
        const mockCall = {
          baseScore: 15,
          callerIDName: "WIRELESS CALLER",
          callerIDNumber: "7184902609",
          domain: "ahavamd.dataphone.cloud",
          event: "member-queue-start",
          joinedEpoch: `${Math.floor(Date.now() / 1000)}`,
          queue: "50000@ahavamd.dataphone.cloud",
          sessionUUID: crypto.randomUUID(),
          uuid: crypto.randomUUID(),
          state: "Queued"
        };

        console.log("🧪 Dispatching mock queued call", mockCall);
        dispatch(updateCallCenterCalls(mockCall));
      }, 2000);
      */
    });

    socket.on("callcenter-update", (data) => {

      if (data.event === "member-queue-start" || data.event === "member-queue-resume") {
        dispatch(updateCallCenterCalls(data));
        
      }

      if (data.event == "agent-state-change") {
        if (data.state == "Waiting") {
          dispatch(removeAgentsByAgentsId(data.name));
        }
        dispatch(updateCallCenterAgentStatus(data));
      }

      if (data.event === "bridge-agent-start") {
        dispatch(updateActiveCallsCallCenter(data));
        dispatch(removeCallCenterCallByAgentId(data.memberSessionUUID));
        dispatch(removeAgentsOfferingBySessionId(data.memberSessionUUID));
      }

      if (data.event === "member-queue-end") {
        dispatch(removeCallCenterCallByAgentId(data.sessionUUID));
        dispatch(removeActiveCallsCallCenter(data.sessionUUID));
        dispatch(removeAgentsOfferingBySessionId(data.sessionUUID));
      }

      if (data.event === "bridge-agent-end") {
        dispatch(removeActiveCallsCallCenter(data.memberSessionUUID));
        dispatch(removeAgentsOfferingBySessionId(data.sessionUUID));
      }

      if (data.event === "agent-offering") {
        dispatch(createAgentsOffering(data));
      }
    });

    socket.on("auth-failure", (data) => {
      console.log(data);
    });

    socket.on("disconnect", (reason) => {
      console.log("client disconnected", reason);
      dispatch(removeAllActiveCallCenterData())
      dispatch(removeAllCallCenterHoldCalls())
    });

    socket.on("connect_error", (err) =>
      console.error("❌ Call Center Socket connect error:", err)
    );

    return () => {
      console.log("🧹 Cleaning up socket connection...");
      socket.disconnect();
    };
  }, [socket]);
};

export default useCallCenterSocket;
